import React from 'react';
import { configurations, configSectionContent } from '../data/mock';
import { getImageUrl } from '../lib/api';
import { Box, TreeDeciduous, Square, Keyboard, Wifi, Smartphone } from 'lucide-react';

const iconMap = {
  1: Box,
  2: TreeDeciduous,
  3: Square,
  4: Keyboard,
  5: Wifi,
  6: Smartphone
};

const ConfigurationsSection = () => {
  return (
    <section className="py-20 lg:py-32 bg-slate-50" id="configurations">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
            {configSectionContent.title}
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            {configSectionContent.description}
          </p>
          <div className="w-16 h-1 bg-slate-800 mx-auto mt-6" />
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {configurations.map((config) => {
            const Icon = iconMap[config.id] || Box;
            return (
              <div
                key={config.id}
                className="group bg-white rounded-xl p-6 text-center hover:shadow-lg hover:shadow-slate-100 transition-all duration-300 border border-slate-100"
              >
                <div className="aspect-square bg-slate-50 rounded-lg overflow-hidden mb-4 flex items-center justify-center group-hover:bg-slate-100 transition-colors">
                  <img
                    src={getImageUrl(config.image)}
                    alt={config.altText}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      const iconContainer = document.createElement('div');
                      iconContainer.className = 'flex items-center justify-center w-full h-full';
                      e.target.parentElement.appendChild(iconContainer);
                    }}
                  />
                  <Icon className="w-12 h-12 text-slate-400 group-hover:text-slate-600 transition-colors hidden" />
                </div>
                <h3 className="font-medium text-slate-900 text-sm">
                  {config.name}
                </h3>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ConfigurationsSection;
